export const URLS = {
  renderings: {
    turnItOn: 'https://form.jotform.com/222124104465040',
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgnQAG&campaignMedium=Website&campaignSource=Renderings',
    consumerRenderings: 'https://hover.to/renderings/new',
  },
  homePage: {
    chatWithARep:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XAduQAG&campaignMedium=Website&campaignSource=Website%20Homepage',
  },
  trustedByNames: {
    chatWithARep:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XAduQAG&campaignMedium=Website&campaignSource=Website%20Homepage',
  },
  navBar: {
    chatWithARep:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XBK5QAO&campaignMedium=Website&campaignSource=Website%20Nav%20Bar',
    scheduleDemo:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XBK5QAO&campaignMedium=Website&campaignSource=Website%20Nav%20Bar',
  },
  newConstructionSolution: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgdQAG&campaignMedium=Website&campaignSource=New%20Construction%20Solution',
  },
  exteriorHouseDesign: {
    StartFreeTrial: 'https://hover.to/signup',
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgYQAW&campaignMedium=Website&campaignSource=Website',
  },
  insurance: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDfzQAG&campaignMedium=Website&campaignSource=Hover%20for%20Insurance',
  },
  architects: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgEQAW&campaignMedium=Website&campaignSource=Architects%20-%20Website',
  },
  exteriorContractors: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDg4QAG&campaignMedium=Website&campaignSource=Website%20Exterior%20Contractors',
  },
  restoration: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDg4QAG&campaignMedium=Website&campaignSource=Website%20Exterior%20Contractors',
  },
  howToMeasureRoof: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDg4QAG&campaignMedium=Website&campaignSource=Website%20Exterior%20Contractors',
  },
  directOrdering: {
    scheduleMeeting:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgiQAG&campaignMedium=Website&campaignSource=Direct%20Ordering',
  },
  pricing: {
    scheduleMeeting:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgJQAW&campaignMedium=Website&campaignSource=Website',
    contactSales:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgJQAW&campaignMedium=Website&campaignSource=Website',
    scheduleDemo:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgJQAW&campaignMedium=Website&campaignSource=Website',
    addAdvancedExports:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgOQAW&campaignMedium=Website&campaignSource=Advanced%20Exports',
  },
  transformPlan: {
    scheduleDemo:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgTQAW&campaignMedium=Website&campaignSource=Transform',
  },
  hoverReports: {
    contactSales:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDgJQAW&campaignMedium=Website&campaignSource=Website',
  },
  interiors: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XIuZQAW&campaignMedium=&campaignSource=Interiors',
    getEarlyAccess: 'https://form.jotform.com/222515716706152',
  },
  vinylSidingEstimator: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDg4QAG&campaignMedium=Website&campaignSource=Website Vinyl Siding Estimator',
  },
  measurementsOfHouse: {
    chatWithUs:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XDg4QAG&campaignMedium=Website&campaignSource=Website Measurements of a House',
  },
};
